import { TitleProps as VdsTitleProps } from "@vds/typography";
import MdToHtml from "../MdToHtml/MdToHtml";
import { StyledSiteAlertBanner } from "./SiteAlertBanner.module";
import Title from "../typography/Title/Title";

type SiteAlertBannerProps = {
  content: any;
  title?: any;
  backgroundColor?: string;
  textColor?: VdsTitleProps["color"];
  fontWeight?: string | number;
};

const SiteAlertBanner = ({
  content,
  title,
  backgroundColor = "#0088ce",
  textColor = "#ffffff",
  fontWeight = "bold",
}: SiteAlertBannerProps) => {
  return (
    <StyledSiteAlertBanner
      className="brand-central-site-alert-banner"
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      $fontWeight={fontWeight}
    >
      <Title bold size="small" color={textColor}>
        {title}
      </Title>
      <MdToHtml
        content={content}
        linkSize="large"
        pSize="large"
        color={textColor}
        pMargin="0"
        linkTextDecoration
      ></MdToHtml>
    </StyledSiteAlertBanner>
  );
};

export default SiteAlertBanner;
